<template>
  <div>
    <!-- NAV-MENU -->
    <div
      class="nav-menu"
      style="height: 45px; width: 100%; padding: 0px; padding-top: 0.3%; text-align: center;"
    >
      <router-link to="/board-directory" style="text-decoration: none">
        <span
          style="
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: transparent;
            border-radius: 50%;
            width: 34px;
            height: 34px;
            margin-left: 10px;
            border: 2px solid white;
          "
        >
          <v-icon color="#fff" size="35">mdi-arrow-left</v-icon>
        </span>
      </router-link>
      <router-link to="/dashboard" style="text-decoration: none">
        <v-icon color="#fff" size="35" style="margin-left: 10px;"
          >mdi-home</v-icon
        >
      </router-link>
      <p style="font-weight: bold; font-size: 24px; margin-left: 40%;">
        Skill Matrix
      </p>
      <v-spacer></v-spacer>
      <v-menu location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn
            class="btn text-white"
            variant="text"
            v-bind="props"
          >
            {{ selectedCompanyName }}
          </v-btn>
        </template>

        <div class="mt-4">
          <SelectCompany :companies="companyList" @company_selected="changeCompanyDetails" />
        </div>
      </v-menu>
      <v-btn
        class="mt-n3 ml-n5"
        size="x-large"
        variant="outlined"
        icon
        color="#ffffff"
        @click="reloadPage"
        style="margin-right: 50px; border: none;"
      >
        <v-icon>mdi-cached</v-icon>
      </v-btn>
    </div>

    <!-- COMPONENT -->
    <div class="component">
      <div>
        <v-card 
          class="mx-auto pa-4"
          elevation="0"
        >
          <v-row no-gutters>
            <v-col cols="4" md="4" sm="4">
              <v-card-text>
                <v-tabs
                  v-model="categoryTab"
                  centered
                  color="rgb(227, 58, 58)"
                  hide-slider
                  class="left-tabs"
                >
                  <v-tab 
                    value="category" 
                    class="directory text-white" 
                    style="flex: 1 1 100%; width: 100%; justify-content: center;"
                  >
                    Category
                  </v-tab>
                </v-tabs>
                <v-window v-model="categoryTab">
                  <v-window-item value="category">
                    <v-card style="border: 2px solid rgb(227, 58, 58); padding: 0; height: 100vh; overflow-y: scroll;">
                      <v-card-text>
                        <div style="overflow: auto;">
                          <v-list subheader two-line>
                            <template v-if="categories && categories.length">
                              <v-list-item-group
                                v-model="selectedCategoryId"
                                active-class="directory text-white"
                              >
                                <div
                                  v-for="(category, index) in categories"
                                  :key="category.skillMatrixCategoryId"
                                >
                                  <v-list-item
                                    :value="category.skillMatrixCategoryId"
                                    @click="selectCategory(category)"
                                    :class="selectedCategoryId == category.skillMatrixCategoryId ? 'directory text-white' : ''"
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        {{ category.skillMatrixCategoryTitle }}
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-divider
                                    v-if="index < categories.length - 1"
                                    :key="index"
                                    color="black"
                                  ></v-divider>
                                </div>
                              </v-list-item-group>
                            </template>
                            <template v-else>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title class="text-center">
                                    No categories found
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-list>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-window-item>
                </v-window>
              </v-card-text>
            </v-col>
            <v-col cols="8" md="8" sm="8">
              <v-card-text>
                <v-tabs
                  v-model="selectedSkillsetId"
                  color="rgb(227, 58, 58)"
                  hide-slider
                  class="profile-tabs"
                >
                  <v-tab
                    v-for="skill in categoryItems"
                    :key="skill.skillsetId"
                    :value="skill.skillsetId"
                    :class="selectedSkillsetId == skill.skillsetId ? 'directory text-white' : ''"
                    style="display: flex; flex-direction: column; align-items: center; min-width: 120px;"
                    @click="selectCategorySkillset(skill)"
                  >
                    <div style="display: flex; flex-direction: column; align-items: center; width: 100%;">
                      <span style="font-weight: bold;">{{ skill.skillsetName }}</span>
                      <span style="font-size: 12px;">Level: {{ skill.currentLevelName }}</span>
                    </div>
                  </v-tab>
                </v-tabs>

                <v-window v-model="selectedSkillsetId">
                  <v-window-item
                    v-for="skill in categoryItems"
                    :key="skill.skillsetId"
                    :value="skill.skillsetId"
                  >
                    <v-card style="border: 2px solid rgb(227, 58, 58); padding: 0; height: 100vh; overflow-y: scroll;">
                      <v-card-text 
                        v-if="!show"
                      > 
                        <div style="width: 100%; overflow: auto;">
                          <v-table 
                            v-if="skills && skills.length > 0"
                            fixed-header
                          >
                            <thead>
                              <tr>
                                <th style="background-color: rgb(227, 58, 58); font-weight: bolder;" class="text-left text-white">Skill Name</th>
                                <th style="background-color: rgb(227, 58, 58); font-weight: bolder;" class="text-left text-white">Available</th>
                                <th style="background-color: rgb(227, 58, 58); font-weight: bolder;" class="text-left text-white">EXP.(YEAR)/Level</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, index) in skills" 
                                :key="index"
                                class="table-striped"
                              >
                                <td style="overflow: hidden; text-overflow: ellipsis; padding-top: 20px; padding-bottom: 20px;">
                                  {{ item.skillName }}
                                </td>
                                <td style="overflow: hidden; text-overflow: ellipsis;">
                                  <v-checkbox
                                    v-model="item.isAvailable"
                                    color="rgb(227, 58, 58)"
                                    :value="item.isAvailable"
                                    :false-value="0"
                                    :true-value="1"
                                    hide-details
                                    placeholder="Years"
                                    :disabled="selectedCategory?.allowChanges == 0 || !selectedCategory || Object.keys(selectedCategory).length === 0 || !skills || skills.length === 0 || (categoryItems.length > 0 && selectedSkillsetId !== categoryItems[categoryItems.length - 1].skillsetId)"
                                  ></v-checkbox>
                                </td>
                                <td style="overflow: hidden; text-overflow: ellipsis;" v-if="item.levelOptions && item.levelOptions.length > 0">
                                  <v-combobox
                                    :items="item.levelOptions"
                                    variant="solo"
                                    v-model="item.currentLevel"
                                    bg-color="#e6f6ea"
                                    item-title="levelName"
                                    item-value="levelId"
                                    hide-details
                                    :return-object="false"
                                    :disabled="selectedCategory?.allowChanges == 0 || !selectedCategory || Object.keys(selectedCategory).length === 0 || !skills || skills.length === 0 || (categoryItems.length > 0 && selectedSkillsetId !== categoryItems[categoryItems.length - 1].skillsetId)"
                                  ></v-combobox>
                                </td>
                                <td v-else>
                                  <v-combobox
                                    :items="item.levelOptions"
                                    variant="solo"
                                    v-model="item.score"
                                    bg-color="#e6f6ea"
                                    item-title="levelName"
                                    item-value="levelId"
                                    hide-details
                                    :return-object="false"
                                    :disabled="selectedCategory?.allowChanges == 0 || !selectedCategory || Object.keys(selectedCategory).length === 0 || !skills || skills.length === 0 || (categoryItems.length > 0 && selectedSkillsetId !== categoryItems[categoryItems.length - 1].skillsetId)"
                                  ></v-combobox>
                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                          <v-table v-else>
                            <thead>
                              <tr>
                                <th style="background-color: rgb(227, 58, 58); font-weight: bolder;" class="text-left text-white">Skill Name</th>
                                <th style="background-color: rgb(227, 58, 58); font-weight: bolder;" class="text-left text-white">Available</th>
                                <th style="background-color: rgb(227, 58, 58); font-weight: bolder;" class="text-left text-white">EXP.(YEAR)/Level</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td 
                                  colspan="3"
                                  class="text-center"
                                >
                                  <span>
                                    No Skills Found
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                        </div>
                      </v-card-text>
                      <v-card-actions class="flex-column">
                        <v-btn
                          color="rgb(227, 58, 58)"
                          :loading="loading"
                          block
                          variant="elevated"
                          :disabled="selectedCategory?.allowChanges == 0 || !selectedCategory || Object.keys(selectedCategory).length === 0 || !skills || skills.length === 0"
                          @click="updateSkillMatrix"
                        >
                          Save
                        </v-btn>
                        <v-btn
                          color="rgb(227, 58, 58)"
                          :loading="loading"
                          block
                          variant="elevated"
                          :disabled="selectedCategory?.allowChanges == 0 || !selectedCategory || Object.keys(selectedCategory).length === 0 || !skills || skills.length === 0 || (categoryItems.length > 0 && selectedSkillsetId !== categoryItems[categoryItems.length - 1].skillsetId)"
                          @click="finalizeSkillMatrixCategory"
                        >
                          Finalize Category
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-window-item>
                </v-window>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </div>

      <div
        v-if="closePDF"
        style="position: absolute; background-color: #f5f5f5; width: 100%; height: 100%; padding: 1%; overflow: hidden; margin-right: 0;"
      >
        <v-card>
          <v-card-text>
            <v-main>
              <v-container fluid>
                <pspdfkit
                  :pdf-url="pdf"
                  :license-key="LICENSE_KEY"
                  :base-url="baseUrl"
                  @close_pdf="closePdf"
                />
              </v-container>
            </v-main>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <!-- END OF COMPONENT -->
  </div>
</template>

<script>
var moment = require("moment");
import axios from "axios";
import UserData from "../../components/repository/UserData";
import PSPDFKit from "../../components/PSPDFKit.vue";
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";
import prettyBytes from 'pretty-bytes';
import SelectCompany from "../../components/Cards/SelectCompany.vue";

const LICENSE_KEY =
  "qQQYPHkBJYg9n98YtZGZL2uY8ib3CHb3E8Dj3RiiTPsvgF_qiocO0XxGaMx_V-1uvLcE40JEr4tZSsDWZhtO-kE4S3FCyt27Xq6dR5wn1OjFIkHDPM365GbR59ghBaCcrNSTUss9e84jI29OzS3Rc30eSFTuzDZUYdre2bGu-mQe1ZjLEvTXu5TulbFNuQAsyKf9MgZRngnPpD88kNbCeTRdeQzfnBFOsJxqTrIGwojs6A7D5NTmkUVscajtzr9xrWNnjFBRwj8-e2A13Epd8oBxaEIK8Vp20oxnF5-wg7AqB23xBw7paF1uf626NdYD8EorUPMn4VBazooE2KjD-YOfNwV7lPnJ8Vne4bXfXWUhaRhCsVa2Hvxc-vnhwdXUGAvsyuvHw1XURBtVAnH4lwpUPobPTkeHpRU-I_vISh2DDbgEYdwhk1nckVv-VNAmlym2yw7umI60v8YYGkJ0JQVJ70WiAPz4ySQmVG0Z1X6fdg4mksQwp6rAYetnPykrqmWcFFRm5OWdrypUN0Yfmg_oEWzU-O14MXdfCfoAvjC6fhSboG3DxUMdiXa-Dnycuwf8kgWu_O7JqBHtTGcqdH-lFVaJuQ8ExBYkqZlri49j81PBRT8cJ4yl_vnsi5aCgUSE15CCM2rzCBvPpK6k-g==";

export default {
  data: () => ({
    moment: moment,
    companyList: [],
    selectedCompanyName: "",
    selectedCategoryTitle: "",
    selectedCategoryLevel: "",
    selectedCategory: {},
    selectedBoardGroup: {},
    tab: null,
    tab1: null,
    tab2: null,
    selected: [],
    show: false,
    loading: false,

    groups: [],
    users: [],
    members: [],
    categoryItems: [],
    skills: [],

    closePDF: false,
    pdf: "",
    LICENSE_KEY: LICENSE_KEY,

    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
    skillMatrixReport: [],
    skillMatrixReportUrl: "",

    categoryTab: 'category',
    categories: [],
    levels: [],
    selectedCategoryId: null,
    selectedSkillsetId: null,
  }),

  watch: {
    categoryItems: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.selectedSkillsetId = val[0]?.skillsetId;
        }
      }
    },
  },

  methods: {
    formatDate(date) {
      return moment.unix(date).format("DD-MMM-YYYY");
    },

    reloadPage() {
      window.location.reload();
    },

    getPrettyBytes(value) {
      return prettyBytes(parseInt(value));
    },

    closePdf() {
      this.closePDF = !this.closePDF;
      this.shareDocument = false;
    },

    switchToGroups() {
      this.show = !this.show;
      this.getGroupProfile();
      this.getGroupMembers(this.groups[0].skillMatrixCategoryId);
    },

    switchToUsers() {
      this.show = !this.show;
      this.getCategorySkillSets();
    },

    getGroupMembers(skillMatrixCategoryId) {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.category.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.category.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      formData.append("model", "getGroupMembers");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.category.companyDetail.companyId);
      formData.append("skillMatrixCategoryId", skillMatrixCategoryId);
      formData.append("isGroup", 1);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        this.members = response.data.boardMemberList;
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    getSkillMatrixCategoryList(category = null) {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.category.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.category.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      formData.append("model", "getSkillMatrixCategoryList");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.category.companyDetail.companyId);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        if (response?.data?.success == 1) {
          this.categories = response?.data?.skillMatrixCategoryList;
          this.levels = response?.data?.Levels;
          this.getCategorySkillSets(category);
        } else {
          this.alert.showError(response?.data?.message ? response.data.message : "Something went wrong while fetching skill matrix categories. Please try again.");
        }
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    getSkillSets(skillMatrixCategoryId, isRefresh = false) {
      this.categoryItems = [];
      
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.category.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.category.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      formData.append("model", "getSkillSetForCategory");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.category.companyDetail.companyId);
      formData.append("categoryId", skillMatrixCategoryId);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        if (response?.data?.success == 1) {
          this.categoryItems = response?.data?.skillSets || [];
          if (this.categoryItems.length > 0) {
            this.selectedSkillsetId = this.categoryItems[0].skillsetId;
            if (!isRefresh) {
              this.selectCategorySkillset(this.categoryItems[0]);
            }
          } else {
            this.selectedSkillsetId = null;
          }
        }
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    selectCategorySkillset(skillset) {
      this.selectedSkillsetId = skillset?.skillsetId;
      if (this.selectedSkillsetId) {
        this.getSkillsForSkillSet();
      }
    },

    getSkillsForSkillSet() {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.category.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.category.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      formData.append("model", "getSkillsForSkillSet");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.category.companyDetail.companyId);
      formData.append("categoryId", this.selectedCategory?.skillMatrixCategoryId);
      formData.append("skillSetId", this.selectedSkillsetId);
      formData.append("from", 0);
      formData.append("count", 100);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        if (response?.data?.success == 1) {
          this.skills = (response.data?.skills || []).map(skill => ({
            ...skill,
            skillSetId: skill.skillSetId || skill.skillsetId
          }));
        }
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    finalizeSkillMatrixCategory() {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.category.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.category.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      formData.append("model", "finaliseSkillMatrix");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.category.companyDetail.companyId);
      formData.append("skillMatrixCategoryId", this.selectedCategory?.skillMatrixCategoryId);

      this.loading = true;
      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        if (response.data.success == 1) {
          this.alert.showSuccess(response.data.message);
          this.getSkillMatrixCategoryList(this.selectedCategory);
          this.loading = false;
        } else {
          this.alert.showError(response?.data?.message ? response?.data?.message : (response?.response?.data?.message ?? "Something went wrong while updating skill matrix. Please try again."));
          this.loading = false;
        }
      })
      .catch((e) => {
        console.log("Error", e);
        this.loading = false;
      });
    },

    updateSkillMatrix() {
      const filteredSkills = this.skills.map(skill => ({
        skillId: skill.skillId,
        skillSetId: skill.skillSetId,
        isAvailable: skill.isAvailable,
        currentLevel: skill.currentLevel,
        comment: skill.comment || "",
        score: (skill.score !== undefined && skill.score != '') ? skill.score : null
      }));
    
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.category.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.category.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
      formData.append("model", "updateSkillMatrix");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.category.companyDetail.companyId);
      formData.append("categoryId", this.selectedCategory?.skillMatrixCategoryId);
      formData.append("updatedSkills", JSON.stringify(filteredSkills));

      this.loading = true;
      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        if (response?.data?.success == 1) {
          this.alert.showSuccess(response?.data?.message);

          if (response.data.currentLevelName) {
            const skillsetIndex = this.categoryItems.findIndex(
              item => item.skillsetId === this.selectedSkillsetId
            );

            if (skillsetIndex !== -1) {
              this.categoryItems[skillsetIndex].currentLevelName = response?.data?.currentLevelName;
            }
          }

          this.loading = false;
          this.getSkillsForSkillSet();
        } else {
          console.log("Error", response);
          this.alert.showError(response?.data?.message ? response?.data?.message : (response?.response?.data?.message ?? "Something went wrong while updating skill matrix. Please try again."));
          this.loading = false;
        }
      })
      .catch((e) => {
        console.log("Error", e);
        this.loading = false;
      });
    },

    getCompanyList() {
      const formData = new FormData();
      formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.category.userInfo.userId);
      formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.category.companyDetail.companyCode);
      formData.append("accessToken", UserData.getAccessToken() ?  UserData.getAccessToken() : this.token);
      formData.append("model", "getCompanyList");
      formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.category.companyDetail.companyId);

      axios.post(UserData.getBaseUrl(), formData).then((response) => {
        this.getCompanyListArr = response.data;
        this.companyList = this.getCompanyListArr.companyList;

        this.companyList.unshift({
          companyId: "0",
          companyName: "Company List",
        });
      })
      .catch((e) => {
        console.log("Error", e);
      });
    },

    getCompanyName() {
      this.selectedCompanyName = UserData.getCompanyName() ? UserData.getCompanyName() : this.category.companyDetail.companyName;
    },
    
    changeCompanyDetails(item) {
      this.auth.setDashboardMenuList(item.dashboardMenuList);
      // Set Repository Company Details
      UserData.setCompanyId(item.companyId);
      UserData.setCompanyName(item.companyName);
      // Set Store Company Details
      this.auth.setCompanyId(item.companyId);
      this.auth.setCompanyName(item.companyName);
      this.getCompanyList();
      this.selectedCompanyName = UserData.getCompanyName() ? UserData.getCompanyName() : this.category.companyDetail.companyName;
    },

    getGroupProfile() {
      if (this.groups?.length > 0) {
        this.selectedCategoryTitle = this.groups[0].boardMemberName;
        this.selectedCategoryLevel = this.groups[0].boardMemberDesignation;
      } 
    },

    setGroupProfile(group) {
      this.selectedBoardGroup = group;
      this.selectedCategoryTitle = group.boardMemberName;
      this.getGroupMembers(group.skillMatrixCategoryId);
    },

    getCategorySkillSets(category = null) {
      if (this.categories.length > 0) {
        if (category && Object.keys(category).length > 0) {
          const updatedCategory = this.categories.find(
            cat => cat.skillMatrixCategoryId === category.skillMatrixCategoryId
          );

          if (updatedCategory) {
            this.selectedCategory = updatedCategory;
            this.selectedCategoryTitle = updatedCategory.skillMatrixCategoryTitle;
            this.selectedCategoryLevel = updatedCategory.currentLevelName;
            this.selectedCategoryId = updatedCategory.skillMatrixCategoryId;
            this.getSkillSets(updatedCategory.skillMatrixCategoryId);
          }
        } else {
          this.selectedCategory = this.categories[0];
          this.selectedCategoryTitle = this.categories[0]?.skillMatrixCategoryTitle;
          this.selectedCategoryLevel = this.categories[0]?.currentLevelName;
          this.selectedCategoryId = this.categories[0]?.skillMatrixCategoryId;
          this.getSkillSets(this.categories[0]?.skillMatrixCategoryId);
        }
      } else {
        this.selectedCategoryTitle = UserData.getUserName() ? UserData.getUserName() : this.category.userInfo.userFullName;
      }
    },

    selectCategory(category) {
      this.selectedCategoryId = category?.skillMatrixCategoryId;
      this.selectedCategory = category;
      this.selectedCategoryTitle = category?.skillMatrixCategoryTitle;
      this.selectedCategoryLevel = category?.currentLevelName;
      this.getSkillSets(category?.skillMatrixCategoryId);
    },

    handleProfileRefresh() {
      if (this.tab === 'tab-1') {
        if (this.selectedCategory && Object.keys(this.selectedCategory).length > 0) {
          this.selectCategory(this.selectedCategory);
        } else if (this.users.length > 0) {
          this.selectCategory(this.users[0]);
        }
      } else if (this.tab === 'tab-2') {
        if (this.selectedBoardGroup && Object.keys(this.selectedBoardGroup).length > 0) {
          this.setGroupProfile(this.selectedBoardGroup);
        } else if (this.groups.length > 0) {
          this.setGroupProfile(this.groups[0]);
        }
      }
    },
    goToSkillMatrix() {
      this.store.setSelectedBoardMember(this.selectedCategory);
      this.$router.push('/skill-matrix');
    },
  },

  computed: {
    category() {
      return this.auth.getLoggedInUser;
    },
    
    sortedData2() {
      if (!this.sort.field) {
        return this.resourceDirectors;
      }
      return this.resourceDirectors.concat().sort((a, b) => {
        if (this.sort.desc) {
          return a[this.sort.field] > b[this.sort.field] ? -1 : 1;
        } else {
          return a[this.sort.field] > b[this.sort.field] ? 1 : -1;
        }
      });
    },
  },

  beforeMount() {
    this.getSkillMatrixCategoryList();
    this.getCompanyList();
    this.getCompanyName();
  },

  mounted() {
    const getResourcePackFolder = JSON.parse(localStorage.getItem("getResourcePackFolder"));
    if (getResourcePackFolder) {
      this.getResourcePackFolder = getResourcePackFolder;
    }
  },

  components: {
    pspdfkit: PSPDFKit,
    SelectCompany,
  },
};
</script>

<style scoped>
.nav-menu {
  margin-top: 0px;
  background-color: rgb(227, 58, 58);
  color: #fff;
  display: flex;
  margin-bottom: 1%;
}

.component {
  width: 99%;
  margin-left: 0.5%;
  margin-right: 0.5%;
  height: 900px;
}

.left {
  width: 20%;
  margin-right: 1%;
  float: left;
  height: 100%;
}

.left-top {
  width: 100%;
  height: 49%;
  margin-bottom: 4%;
  background-color: #f8f9f9;
  border-top: 5px solid rgb(227, 58, 58);
  overflow: auto;
}

.left-bottom {
  width: 100%;
  height: 49%;
  background-color: #f8f9f9;
  border-top: 5px solid rgb(227, 58, 58);
  overflow: auto;
}

.left a {
  color: #000;
  text-decoration: none;
}

.left a:hover {
  color: rgb(227, 58, 58);
}

.right {
  width: 79%;
  float: left;
  background-color: #f8f9f9;
  height: 100%;
  border-top: 5px solid rgb(227, 58, 58);
  overflow: auto;
}

.parent {
  display: flex;
  width: 100%;
}

.filler {
  flex-grow: 1;
}

.left-buttons {
  display: inline;
}

.right-buttons {
  display: inline;
}

button:focus {
  outline: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
}
.table-striped a {
  text-decoration: none;
  color: #000;
}

.table-striped a:hover {
  color: rgb(227, 58, 58);
}

.table-striped a:active {
  color: rgb(227, 58, 58);
}

.directory {
  background-color: rgb(227, 58, 58) !important;
}

.left-tabs button {
  border: 2px solid rgb(227, 58, 58);
  color: rgb(227, 58, 58);
}

.profile-tabs button {
  border: 2px solid rgb(227, 58, 58);
  color: rgb(227, 58, 58);
}

.name {
  cursor: pointer !important;
}

.name:hover {
  color: rgb(227, 58, 58) !important;
}

/* Zebra striping for table rows */
tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}

tbody tr:nth-child(odd) {
  background-color: rgb(250, 205, 205);
}
</style>
